export const environment = {
    production: false,
    development: false,
    homolog: true,
    CHECKOUT_API_URL: 'https://capp-sbcheckout-checkout-api-hml.grayfield-7ea88d36.eastus2.azurecontainerapps.io',
    TRANSACTION_API_URL: 'https://capp-sbcheckout-transaction-hml.victoriousplant-a70cfc45.eastus2.azurecontainerapps.io',
};
